import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const dot = L.divIcon({
  className: "",
  html: '<div style="width:16px;height:16px;border-radius:50%;background:#f97316;border:3px solid #fff;box-shadow:0 0 10px rgba(0,0,0,.45)"></div>',
  iconSize: [16, 16],
  iconAnchor: [8, 8],
});

export default function PickupMap({ points, height = 380, testid = "pickup-live-map" }) {
  if (!points.length) {
    return (
      <div className="grid place-items-center rounded-2xl border border-adminborder bg-admincard text-sm text-slate-500"
           style={{ height }} data-testid={testid}>
        No pickup boys on duty right now.
      </div>
    );
  }
  return (
    <div className="overflow-hidden rounded-2xl border border-adminborder" style={{ height }} data-testid={testid}>
      <MapContainer center={[points[0].lat, points[0].lng]} zoom={12} style={{ height: "100%", width: "100%" }}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap contributors" />
        {points.map((p) => (
          <Marker key={p.user_id} position={[p.lat, p.lng]} icon={dot}>
            <Popup>
              <b>{p.name}</b><br />
              Last update: {p.at ? new Date(p.at).toLocaleTimeString("en-IN") : "—"}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
